module.exports = __webpack_public_path__ + "img/w22.ad3c0ec1.svg";